import { useQuery } from "@apollo/client";
import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import { AuthContext } from "contexts/AuthContext";
import { GET_WITHDRAWALS } from "graphql/queries";
import useAccount from "hooks/useAccount";
import useMerchantProfile from "hooks/useMerchantProfile";
import { chevronBackOutline } from "ionicons/icons";
import { providers } from "pages/LightningServiceProvider/Providers";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AccountStore } from "stores/AccountStore";
import client from "utils/Api";
import "./Withdrawals.css";
import WithdrawalsList from "./WithdrawalsList";

const Withdrawals = () => {
  const { authState } = useContext(AuthContext);
  const { data: merchantKeys, loading: keysLoading } = useMerchantProfile(
    authState.user.uid,
    true
  );
  const [balances, setBalances] = useState([]);
  const [withdrawals, setWithdrawals] = useState();
  const { data, loading, refetch } = useQuery(GET_WITHDRAWALS, {
    variables: { user_id: authState.user.uid },
  });
  const [loaded, setLoaded] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(true);
  const [refetchBalances] = useAccount(authState);
  const axiosClient = client(authState.token);
  const history = useHistory();

  const refreshData = useCallback(async () => {
    setLoadingBalance(true);
    async function getCurrencyRate() {
      const response = await axiosClient.get("/account/managed/balances");
      setBalances(response.data.balances);
      setLoadingBalance(false);
    }

    refetchBalances();
    refetch();
    getCurrencyRate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch, refetchBalances]);

  useEffect(() => {
    async function getWithdrawals() {
      if (data?.withdrawals) {
        setLoaded(true);
        setWithdrawals(data?.withdrawals);
      }
    }
    async function getCurrencyRate() {
      const response = await axiosClient.get("/account/managed/balances");
      setBalances(response.data.balances);
      setLoadingBalance(false);
    }

    getCurrencyRate().then();
    getWithdrawals().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const doRefresh = async (event) => {
    await refreshData();
    event.detail.complete();
  };

  useEffect(() => {
    AccountStore.update((s) => {
      s.balances = balances;
    });
  }, [balances]);

  useIonViewWillEnter(() => {
    refetchBalances();
  });

  return (
    <IonPage
      className={"withdrawals-page-root wallet-root ln-service-provider-root"}
    >
      <IonHeader className={"ion-no-border"}>
        <IonToolbar className={"background-color"}>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Withdrawals</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <IonGrid className={"ion-no-padding"}>
          <IonRow>
            <IonCol>
              {loadingBalance && (
                <IonCard className={"ln-service-card"}>
                  <IonCardHeader>
                    <IonToolbar className={"transparent"}>
                      <div slot="start" className={"logo-container opennode"}>
                        <IonAvatar>
                          <IonSkeletonText />
                        </IonAvatar>
                      </div>
                      <IonChip slot="end">
                        <IonSkeletonText style={{ width: 60 }} />
                      </IonChip>
                    </IonToolbar>
                  </IonCardHeader>
                  <IonCardContent>
                    <h1>
                      <IonSkeletonText />
                    </h1>
                  </IonCardContent>
                </IonCard>
              )}
              {balances?.map((item, i) => {
                return (
                  <div key={item.provider + i}>
                    {item.provider === "opennode" &&
                      merchantKeys.merchants[0]?.kyc_status !== "approved" && (
                        <IonItem routerLink="/account/welcome" lines="none">
                          Complete full setup to enable OpenNode
                        </IonItem>
                      )}
                    <IonCard
                      disabled={
                        keysLoading ||
                        (item.provider === "opennode" &&
                          merchantKeys.merchants[0]?.kyc_status !== "approved")
                      }
                      onClick={() =>
                        history.push(
                          "/account/withdrawals/withdraw/ln/" + item.provider
                        )
                      }
                      className={providers[item.provider].class}
                    >
                      <IonCardHeader>
                        <IonToolbar className={"transparent"}>
                          <div
                            slot="start"
                            className={providers[item.provider].logoContainer}
                          >
                            <img
                              src={providers[item.provider].img}
                              alt={providers[item.provider].name}
                            />
                          </div>
                          <IonChip slot="end">Balance: {item.balance}</IonChip>
                        </IonToolbar>
                      </IonCardHeader>
                      <IonCardContent>
                        <h1>{providers[item.provider].slogan}</h1>
                      </IonCardContent>
                    </IonCard>
                  </div>
                );
              })}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonCard className={"activity-card"}>
                <IonCardContent className={"ion-no-padding ion-padding-top"}>
                  <WithdrawalsList
                    withdrawals={withdrawals}
                    loading={loading}
                    loaded={loaded}
                  />
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Withdrawals;
